export default __webpack_public_path__ + "static/media/magnifyIcon.69312437.png";